<template>
    <div class="h-[220px] md:h-[300px] bg-[#E8F3FA] flex flex-col items-center justify-center relative">
        <div class="absolute inset-0 form-header-img opacity-[15%]"></div>
        <h1 class="relative text-center text-2xl md:text-3xl font-bold leading-relaxed md:leading-relaxed">
            在宅看護指導士<br/>
            認定登録申し込みフォーム
        </h1>
    </div>
</template>

<script>
export default {
    name: "FormHeader"
}
</script>

<style scoped>
.form-header-img {
    background: url('/images/form-header-bg.png') no-repeat center center;
}
</style>
